import { Button } from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import {
  clearGACookies,
  getConsent,
  initGA,
  setConsent
} from './cookie-consent.util'

interface Props {
  gaTrackingId?: string
}

const CookieConsentBanner = ({ gaTrackingId }: Props) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (getConsent() === null) {
      setVisible(true)
    }
  }, [])

  const handleAccept = () => {
    setConsent('accepted')
    if (gaTrackingId) {
      initGA(gaTrackingId)
    }
    setVisible(false)
  }

  const handleDecline = () => {
    setConsent('declined')
    clearGACookies()
    setVisible(false)
  }

  if (!visible) return null

  return (
    <Wrapper
      role="dialog"
      aria-label="Cookie consent"
    >
      <Inner>
        <Message>
          当サイトへご訪問いただきありがとうございます。私たちがより良い情報を提供できるように、
          <Link to="/privacy-policy">プライバシーポリシー</Link>
          に基づいたCookieの取得と利用に同意をお願いいたします。
        </Message>
        <Actions>
          <Button
            type="primary"
            onClick={handleAccept}
            aria-label="Accept cookies"
          >
            同意する
          </Button>
          <Button
            type="link"
            onClick={handleDecline}
            aria-label="Decline cookies"
          >
            Cookieを無効化
          </Button>
        </Actions>
      </Inner>
    </Wrapper>
  )
}

export default CookieConsentBanner

const Wrapper = styled.div`
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 24px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  pointer-events: none;
`

const Inner = styled.div`
  pointer-events: auto;
  max-width: 1200px;
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }
`

const Message = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #333333;
  flex: 1;

  a {
    color: #9bb73f;
    text-decoration: underline;
  }
`

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    justify-content: flex-end;
  }
`
